import { globalAxios, axiosPath, backendVersion } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    customer_only_list: [],
    customerData: [],
    indexLoading: null,
    provinceAdd: [],
    districtAdd: [],
    subDistrictAdd: [],
    zipcodeAdd: [],
    provinceEdit: [],
    districtEdit: [],
    subDistrictEdit: [],
    zipcodeEdit: [],
    customer_address_list: [],
  },
  mutations: {
    resetState(state) {
      state.customer_only_list = [];
      state.customerData = [];
      state.indexLoading = null;
      state.provinceAdd = [];
      state.districtAdd = [];
      state.subDistrictAdd = [];
      state.zipcodeAdd = [];
      state.provinceEdit = [];
      state.districtEdit = [];
      state.subDistrictEdit = [];
      state.zipcodeEdit = [];
      state.customer_address_list = [];
    },
    deleteCustomer(state, item) {
      const index = state.customerData.indexOf(item);
      state.customerData.splice(index, 1);
    },
    getData(state, data) {
      for (let value of data.data) {
        // if (value.user_role == 6 || value.user_role == 7) {
        value.user_address = [];
        state.customerData.push(value);
        // }
      }
    },
    editing(state, index) {
      state.indexLoading = index;
    },
    addCustomer(state, info) {
      state.customerData.push(info);
    },
    getProvinceAdd(state, list) {
      state.provinceAdd = list;
    },
    getDistrictAdd(state, list) {
      state.districtAdd = list;
    },
    getSubDistrictAdd(state, list) {
      state.subDistrictAdd = list;
    },
    getZipCodeAdd(state, list) {
      state.zipcodeAdd = list;
    },
    getProvinceEdit(state, list) {
      state.provinceEdit = list;
    },
    getDistrictEdit(state, list) {
      state.districtEdit = list;
    },
    getSubDistrictEdit(state, list) {
      state.subDistrictEdit = list;
    },
    getZipCodeEdit(state, list) {
      state.zipcodeEdit = list;
    },
    addCustomerAddress(state, new_address) {
      if (new_address.user_address_default == 1) {
        new_address.user_address_default = true;
      } else if (new_address.user_address_default == 0) {
        new_address.user_address_default = false;
      }
      for (let key in state.provinceAdd) {
        if (
          state.provinceAdd[key].province_id ==
          new_address.user_address_province
        ) {
          new_address.user_address_province =
            state.provinceAdd[key].province_name_th;
        }
      }
      for (let key in state.districtAdd) {
        if (
          state.districtAdd[key].district_id ==
          new_address.user_address_district
        ) {
          new_address.user_address_district =
            state.districtAdd[key].district_name_th;
        }
      }
      for (let key in state.subDistrictAdd) {
        if (
          state.subDistrictAdd[key].sub_district_id ==
          new_address.user_address_sub_district
        ) {
          new_address.user_address_sub_district =
            state.subDistrictAdd[key].sub_district_name_th;
        }
      }
      for (let key in state.zipcodeAdd) {
        if (
          state.zipcodeAdd[key].zipcode_id == new_address.user_address_zipcode
        ) {
          new_address.user_address_zipcode = state.zipcodeAdd[key].zipcode_code;
        }
      }

      for (let key in state.customerData) {
        if (state.customerData[key].user_id == new_address.user_address_user) {
          state.customerData[key].user_address.push(new_address);
        }
      }
    },
    deleteCustomerAddress(state, info) {
      let index = state.customerData[
        info.index_customer
      ].user_address.findIndex((val) => {
        return val.user_address_id == info.address_info.user_address_id;
      });
      state.customerData[info.index_customer].user_address.splice(index, 1);
    },
    getCustomerAddressList(state, data) {
      state.customer_address_list = data;
    },
    getOnlyCustomerList(state, data) {
      state.customer_only_list = data;
    },
  },

  actions: {
    async fetchUserOTP({ dispatch }, tel) {
      let url = backendVersion.version + "/searchOTP/" + tel;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        if (res.msg == true) {
          return res.data;
        } else {
          return "NO OTP AVAILABLE";
        }
      }
    },
    async fetchUserOTPMerchant({ dispatch }, tel) {
      let url = backendVersion.version + "/merChant/searchOTP/" + tel;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        if (res.msg == true) {
          return res.data;
        } else {
          return "NO OTP AVAILABLE";
        }
      }
    },
    async getCustomerAddressDetail(
      { state, rootState, dispatch, commit },
      customer_id
    ) {
      let url = backendVersion.version + "/customer_address/" + customer_id;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        return res;
      }
    },
    async getOnlyCustomerList({ state, rootState, dispatch, commit }) {
      // let url = backendVersion.version + "/list/customers";
      // let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
      //   root: true,
      // });
      // if (typeof res == "boolean" && res == false) {
      //   return false;
      // } else {
      commit("getOnlyCustomerList", []);
      return true;
      // }
    },
    async getCustomerAddressList(
      { state, rootState, dispatch, commit },
      customer_id
    ) {
      state.customer_address_list = [];
      let url =
        rootState.api_urls.fetchCustomerBack_getCustomerAddressList +
        customer_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getCustomerAddressList", res);
        return true;
      }
    },
    async setAsDefault({ dispatch }, sendData) {
      let url =
        backendVersion.version +
        "/edit/customer_address/" +
        sendData.user_address_id;
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form: sendData },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return "error";
      } else {
        return res;
      }
    },
    async deleteCustomerAddress({ commit, dispatch }, send_data) {
      let url =
        backendVersion.version +
        "/delete/customer_address/" +
        send_data.address_info.user_address_id;
      let res = await dispatch("fetchGeneral/coreInstanceDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("deleteCustomerAddress", send_data);
      }
    },
    async editCustomerAddress({ dispatch }, info) {
      let url =
        backendVersion.version +
        "/edit/customer_address/" +
        info.user_address_id;
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form: info },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return "error";
      } else {
        return "completed";
      }
    },
    async deleteCustomer({ commit, dispatch }, item) {
      let url = backendVersion.version + "/delete/customer/" + item.user_id;
      let res = await dispatch("fetchGeneral/coreInstanceDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        // commit("deleteCustomer", item);
        return true;
      }
    },
    async getData({ commit, state, dispatch }, config = {}) {
      state.customerData = [];
      state.indexLoading = null;
      let url = backendVersion.version + "/customers";
      return globalAxios
        .get(url, { params: config })
        .then(res => {
          commit("getData", res);
          return res
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });


    },
    async editCustomer({ commit, state, dispatch }, cusInfo) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      };
      let url = backendVersion.version + "/edit/customer/" + cusInfo.user_id;
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form: cusInfo },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        commit("editing", null);
        return "error";
      } else {
        commit("editing", null);
        return "completed";
      }
    },
    async addCustomer({ commit, dispatch }, info) {
      let url = backendVersion.version + "/create/customer";
      let res = await dispatch(
        "fetchGeneral/coreInstancePostData",
        { url, form: info },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return "error";
      } else {
        commit("addCustomer", res);
        return res.user_id;
      }
    },
    async getProvinceAdd({ commit, state, dispatch }) {
      state.provinceAdd = [];
      state.districtAdd = [];
      state.subDistrictAdd = [];
      state.zipcodeAdd = [];
      let url = backendVersion.version + "/province/onuse";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return 0;
      } else {
        commit("getProvinceAdd", res);
        return res;
      }
    },
    async getDistrictAdd({ commit, state, dispatch }, id) {
      state.subDistrictAdd = [];
      state.zipcodeAdd = [];
      let url = backendVersion.version + "/select/district/" + id;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getDistrictAdd", res);
      }
    },
    async getSubDistrictAdd({ commit, state, dispatch }, id) {
      let url = backendVersion.version + "/select/sub_district/" + id;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getSubDistrictAdd", res);
      }
    },
    async getZipCodeAdd({ commit, state, dispatch }, id) {
      let url = backendVersion.version + "/select/zipcode/" + id;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getZipCodeAdd", res);
      }
    },
    async addCustomerAddress({ commit, dispatch }, info) {
      let url = backendVersion.version + "/create/customer_address";
      let res = await dispatch(
        "fetchGeneral/coreInstancePostData",
        { url, form: info },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("addCustomerAddress", res);
      }
    },
    async getProvinceEdit({ commit, state, dispatch }) {
      state.provinceEdit = [];
      state.districtEdit = [];
      state.subDistrictEdit = [];
      state.zipcodeEdit = [];
      let url = backendVersion.version + "/province/onuse";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getProvinceEdit", res);
        return res;
      }
    },
    async getDistrictEdit({ state, commit, dispatch }, id) {
      state.districtEdit = [];
      state.subDistrictEdit = [];
      state.zipcodeEdit = [];
      let url = backendVersion.version + "/select/district/" + id;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return 0;
      } else {
        commit("getDistrictEdit", res);
        return res;
      }
    },
    async getSubDistrictEdit({ state, commit, dispatch }, id) {
      state.subDistrictEdit = [];
      let url = backendVersion.version + "/select/sub_district/" + id;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getSubDistrictEdit", res);
        return res;
      }
    },
    async getZipCodeEdit({ commit, dispatch }, id) {
      let url = backendVersion.version + "/select/zipcode/" + id;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getZipCodeEdit", res);
        return res;
      }
    },
  },
  getters: {},
};
